var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DoNotTrack',{attrs:{"placeholder":"👤"}},[_c('span',{staticClass:"avatar",style:(_vm.getStyle)},[_c('img',{attrs:{"src":require("@/assets/images/icons/EDU_staff_PP.jpg"),"role":"presentation","alt":"EDU staff"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }